import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import logo from '../../assets/imgs/star_behaviors_logo.png'
const Header = () => {
    const user = localStorage.getItem("token1");
    const navigate = useNavigate();
    const location = useLocation();
    let isLoggedIn = false;
    if (user) {
        isLoggedIn = true;
    }
    const handleLogout = () => {
        localStorage.removeItem("token1");
        navigate('/user-login');
        isLoggedIn = false;
        // window.location.reload();
    };

    const path = location.pathname;
    console.log('path = ', path)

    return (
        <>
            <div className="navbar navbar-light bg-primary p-2" >
                <img
                    src={logo} width="136" height="48" alt="Star Behaviors Logo" />
                {user &&
                    <div className="d-flex justify-content-end align-items-center">
                        <button className="nav-link btn btn-link text-white " onClick={handleLogout}>Logout</button>
                    </div>
                }

                {
                    path === '/user-login' && (
                        <Link to="/user-register" className="btn btn-link text-white">
                            Register
                        </Link>
                    )
                }

            </div>


        </>
    );
};

export default Header;
